import Carousel from './modules/carousel';
import Newsletter from './modules/newsletter';
import Commercial from './modules/commercial';
import Cmp from './modules/cmp';
import Gallery from './modules/gallery';
import Togglers from './modules/togglers';
import Global from './modules/global';
import Biorhythm from './modules/biorhythm';
import Compatibility from './modules/compatibility';
import Tarot from './modules/tarot';
import RFVTracker from './modules/rfv';

const modules = {
  Carousel,
  Newsletter,
  Commercial,
  Cmp,
  Gallery,
  Togglers,
  Global,
  Biorhythm,
  Compatibility,
  Tarot,
  RFVTracker
};

var elements = document.querySelectorAll('.joomla-script-options');
if (elements.length > 0) {
  var options = JSON.parse(elements[0].text || elements[0].textContent);
  options.modules.forEach((module) => {
    if (modules[module.name]) {
      new modules[module.name](module.options);
    }
  });
}
